/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_DownInputs */

const cs_gallery_down = /** @type {(inputs: Gallery_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolů`)
};

const en_gallery_down = /** @type {(inputs: Gallery_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Down`)
};

/**
* | output |
* | --- |
* | "Down" |
*
* @param {Gallery_DownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_down = /** @type {((inputs?: Gallery_DownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_DownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_down(inputs)
	return cs_gallery_down(inputs)
});